export default __webpack_public_path__ + "static/media/475513da1d9b9d4e5ee631c81d04abed.png";